import { useQuery } from '@tanstack/react-query';

import { legalEntityApi } from './legal-entity-api';
import { LEGAL_ENTITY_QUERY_KEYS } from './query-keys';

export const myLegalEntitiesQueryOptions = {
  queryKey: LEGAL_ENTITY_QUERY_KEYS.mine(),
  queryFn: () => legalEntityApi.fetchMine(),
};

export function useMyLegalEntities() {
  return useQuery(myLegalEntitiesQueryOptions);
}
